import React from 'react'

const EtDeleteOrganization = () => {
  return (
    <div>EtDeleteOrganization</div>
  )
}

export default EtDeleteOrganization